import { formatDate } from '@/shared/utils'
import type { VisitorType } from '@/shared/types/store.types'

export default class Visitor {
  firstName = ''
  lastName = ''
  birthDate = null
  nationality = null
  nationalityName = null
  country = null
  passport = ''
  passportImage = null
  documentId = null
  visa = ''
  email = ''
  phoneInfo = {
    phone: '+974',
    countryCode: 'QA',
    isValid: false,
  }
  id = ''
  srNo = 0
  getVisa = true
  contactsSame = true
  relationship = ''
  relationshipName = ''
  gender = 1
  passportExpiryDate = null
  visaValidityDate = undefined
  policyDuration = undefined
  maritalStatus = ''

  constructor(dto: VisitorType, id: string) {
    Object.assign(this, dto)
    this.id = id
  }

  toRequest() {
    const birthDate = this.birthDate !== null ? formatDate(new Date(this.birthDate), 'en') : null
    const passportDate = this.passportExpiryDate !== null ? formatDate(new Date(this.passportExpiryDate), 'en') : null
    const _visaValidityDate = this.visaValidityDate ? formatDate(this.visaValidityDate, 'en') : ''

    return {
      srNo: this.srNo,
      FirstName: this.firstName,
      LastName: this.lastName,
      DateOfBirth: birthDate,
      RelationCode: this.relationship,
      RelationName: this.relationshipName,
      NationalityCode: this.nationality,
      NationalityName: String(this.nationalityName).toUpperCase(),
      ResidenceCountry: this.country,
      PassportNo: this.passport,
      PassportExpiryDate: passportDate,
      Email: this.email,
      Phone: this.phoneInfo.phone.replace(/\s/g, ''),
      PhoneCountry: this.phoneInfo.countryCode,
      VisaNo: this.getVisa ? '' : this.visa,
      Gender: this.gender,
      VisaValidityDate: _visaValidityDate,
      PolicyDuration: this.policyDuration || null,
      ...(this.maritalStatus && { maritalStatus: this.maritalStatus }),
    }
  }
}
